import { GetProductByMerchantFilteredRequest } from './../../../../../models/product/get-product-by-merchant-filtered';
import { MessageService } from 'primeng/api';
import {
  AfterViewInit,
  Component,
  EventEmitter,
  OnInit,
  Output,
} from '@angular/core';
import { AppDataService, ProductService } from 'app/services';
import { FormControl } from '@angular/forms';
import { map, Observable, startWith } from 'rxjs';
import { MeasureUnitEnum, UOMCategory } from 'app/models';

@Component({
  selector: 'product-filter',
  templateUrl: './product-filter.component.html',
  styleUrl: './product-filter.component.scss',
  providers: [MessageService],
})
export class ProductFilterComponent implements OnInit, AfterViewInit {
  @Output() applyFilter = new EventEmitter<any>();
  @Output() closeDrawer = new EventEmitter<boolean>();
  @Output() cancelFilter = new EventEmitter<boolean>();

  min = 0;
  max = 100;

  measureUnitEnum = MeasureUnitEnum;
  selectedUOM: string = '';

  options: any[] = []; // TODO Create Category model
  categoryFormControl = new FormControl();
  categorySelected: any;
  categorySelectedSet = new Set<any>(); // TODO Create Category model
  filteredOptions!: Observable<any[]>;
  uomCategories = UOMCategory.UOMCategoryList;

  constructor(
    private productService: ProductService,
    private messageService: MessageService,
    private appData: AppDataService
  ) {}

  ngOnInit(): void {
    this.getAllCategories();
    this.filteredOptions = this.categoryFormControl.valueChanges.pipe(
      startWith(''),
      map((value) => this.filter(value || ''))
    );
  }

  ngAfterViewInit(): void {}

  formatLabel(value: number): string {
    if (value >= 1000) {
      return `${Math.round(value / 1000)}`;
    }

    return `${value}`;
  }

  addCategorySelected(store: any) {
    this.categorySelectedSet.add(this.categorySelected);
    this.categoryFormControl.setValue('');
  }

  private filter(value: any): string[] {
    const filterValue = value.toString().toLowerCase();

    return this.options.filter((option) =>
      option.Name.toLowerCase().includes(filterValue)
    );
  }

  private getAllCategories(): void {
    const dto = {
      ParentId: null,
      GetAll: true,
      MerchantId: null,
    };
    this.productService
      .getCategories(dto, this.messageService)
      .then((data) => {
        if (!data) {
          return;
        }

        this.options = data;
      })
      .catch((err) => {
        throw err;
      });
  }

  removeCategory(category: any) {
    this.categorySelectedSet.delete(category);
  }

  apply() {
    const dto: GetProductByMerchantFilteredRequest = {
      MerchantId: +this.appData.authData.MerchantId,
      PriceStart: this.min,
      PriceEnd: this.max,
      Skip: 0, // TODO Get skip from parent component
      Take: 10, // TODO Get Take from parent component
      SelectedUOMCategory: this.selectedUOM, // TODO NOT Yet implemented
      SelectedCategoryIds: Array.from(this.categorySelectedSet).map(
        (c) => c.Id
      ),
      SortOrder: 1,
    };

    console.log(dto);
    this.applyFilter.emit(dto);
  }
}
